import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import { BaseBackResponse, FileId } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}salesforce/workorder/create`;

interface CreateWorkOrderCommandPayload {
  fileId: FileId;
  workTypeId: string;
}

async function createWorkOrderCommand({
  fileId,
  workTypeId,
}: CreateWorkOrderCommandPayload): Promise<BaseBackResponse> {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        fileId,
        workTypeId,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default createWorkOrderCommand;
